import Application from 'src/Application';
import uiConfig from 'src/lib/ui/config';
import { ImageCoverView } from '@play-co/timestep-core/ui';
import ResponsiveScene from './ResponsiveScene';
import { Transition } from 'src/game/logic/SceneManager';
import StateObserver from 'src/StateObserver';

export default class DiningRoomScene extends ResponsiveScene {
  private mat: ImageCoverView;

  constructor() {
    super(
      new ImageCoverView({
        ...uiConfig.buruburu.backgroundDefaults,
        ...uiConfig.buruburu.diningRoom,
      }),
    );

    this.getView().tag = 'diningRoom';

    this.addMatAsset();
  }

  private addMatAsset() {
    const scene = this.getView();
    this.mat = scene.addSubview(
      new ImageCoverView(uiConfig.buruburu.diningRoomMat),
    );
  }

  public transition(): Transition {
    const visitingFriend = !!StateObserver.getState().user.visit.visitSession;

    this.mat.updateOpts(
      visitingFriend
        ? uiConfig.buruburu.diningRoomMatDouble
        : uiConfig.buruburu.diningRoomMat,
    );

    return 'slide_forward';
  }
}
